/* Ember-drift particle canvas. Lightweight, count-capped, DPR-aware.
   Runs only for [data-embers] canvases, pauses when off-screen, and is
   fully disabled under prefers-reduced-motion. */
(function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const PALETTE = ["#ff8a3d", "#e0562a", "#ffb066", "#c8402a"];

  class EmberField {
    constructor(canvas) {
      this.canvas = canvas;
      this.ctx = canvas.getContext("2d");
      this.embers = [];
      this.running = false;
      this.dpr = Math.min(window.devicePixelRatio || 1, 2);
      this.resize();
      this.seed();

      this.onResize = () => this.resize();
      window.addEventListener("resize", this.onResize, { passive: true });

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => (e.isIntersecting ? this.start() : this.stop()));
      });
      io.observe(canvas);
    }

    resize() {
      const r = this.canvas.getBoundingClientRect();
      this.w = r.width;
      this.h = r.height;
      this.canvas.width = Math.floor(this.w * this.dpr);
      this.canvas.height = Math.floor(this.h * this.dpr);
      this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
      this.count = Math.max(18, Math.min(52, Math.round(this.w / 26)));
    }

    spawn(initial) {
      return {
        x: Math.random() * this.w,
        y: initial ? Math.random() * this.h : this.h + Math.random() * 24,
        r: 0.6 + Math.random() * 1.8,
        vy: 0.15 + Math.random() * 0.5,
        vx: (Math.random() - 0.5) * 0.25,
        life: 0,
        ttl: 160 + Math.random() * 220,
        color: PALETTE[(Math.random() * PALETTE.length) | 0],
      };
    }

    seed() {
      this.embers = [];
      for (let i = 0; i < this.count; i++) this.embers.push(this.spawn(true));
    }

    step() {
      if (!this.running) return;
      const { ctx } = this;
      ctx.clearRect(0, 0, this.w, this.h);
      if (this.embers.length !== this.count) this.seed();

      for (let i = 0; i < this.embers.length; i++) {
        const p = this.embers[i];
        p.life++;
        p.y -= p.vy;
        p.x += p.vx + Math.sin((p.life + i) * 0.03) * 0.15;
        if (p.y < -10 || p.life > p.ttl) this.embers[i] = this.spawn(false);

        const fade = Math.min(1, p.life / 30) * (1 - p.life / p.ttl);
        ctx.globalAlpha = Math.max(0, fade) * 0.9;
        ctx.fillStyle = p.color;
        ctx.shadowBlur = 6;
        ctx.shadowColor = p.color;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      ctx.shadowBlur = 0;
      this.raf = requestAnimationFrame(() => this.step());
    }

    start() {
      if (this.running) return;
      this.running = true;
      this.step();
    }
    stop() {
      this.running = false;
      cancelAnimationFrame(this.raf);
    }
  }

  function init() {
    document.querySelectorAll("[data-embers]").forEach((c) => {
      if (!c.dataset.emberInit) {
        c.dataset.emberInit = "1";
        new EmberField(c);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();
